import { SortDirection } from "../Enum/SortDirection";

export const sortArray = <T extends unknown>(
  items: Array<T>,
  sortBy: string,
  sortDirection: SortDirection
): Array<T> => {
  if (sortDirection === SortDirection.Ascending) {
    return items.sort((itemA, itemB) => 0 - (itemA[sortBy] > itemB[sortBy] ? -1 : 1));
  }

  return items.sort((itemA, itemB) => 0 - (itemA[sortBy] > itemB[sortBy] ? 1 : -1));
};

export const uniqueValues = <T extends string | number>(items: T[]): T[] => {
  return Array.from(new Set(items).values());
};
